import { render } from "./NoDataCard.vue?vue&type=template&id=12eae04a"
import script from "./NoDataCard.vue?vue&type=script&lang=js"
export * from "./NoDataCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
